import React from "react";
import "../../Styles/yellowcalf.css/Invoice_Balance_Report.css";

function Invoice_Balance_Report() {
  return (
    <div className="invoice-balance-report-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Invoice Balance Report</h4>
        <button className="btn btn-primary">
          Export <i className="fa fa-angle-down"></i>
        </button>
      </div>

      <div className="yc-list-filter">
        <select id="student_id" className="form-select invoice-balance-report-select">
          <option value="">Select Grade</option>
          <option value="189">ssds - hjh45</option>
          <option value="207">hebu - 78787878</option>
          <option value="211">siva - 34567889</option>
          <option value="186">Kaleem - 456</option>
        </select>

        <select id="student_id" className="form-select invoice-balance-report-select">
          <option value="">Select Division</option>
          <option value="189">ssds - hjh45</option>
          <option value="207">hebu - 78787878</option>
          <option value="211">siva - 34567889</option>
          <option value="186">Kaleem - 456</option>
        </select>

        <select id="student_id" className="form-select invoice-balance-report-select">
          <option value="">Select All Students</option>
          <option value="189">ssds - hjh45</option>
          <option value="207">hebu - 78787878</option>
          <option value="211">siva - 34567889</option>
          <option value="186">Kaleem - 456</option>
        </select>

        <button
          type="submit"
          className="btn btn-primary"
        >
          Search
        </button>
        <button
          type="reset"
          className="btn btn-primary"
        >
          Clear
        </button>
      </div>
    </div>
  );
}

export default Invoice_Balance_Report;
